import { HTMLAttributes, PropsWithChildren } from 'react';
import { CSSProperties } from 'styled-components';
import { omitBy } from 'lodash-es';

export const Flex = ({
  children,
  direction,
  align,
  justify,
  gap,
  ...props
}: PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    direction?: CSSProperties['flexDirection'];
    align?: CSSProperties['alignItems'];
    justify?: CSSProperties['alignItems'];
    gap?: CSSProperties['gap'];
  }
>) => {
  const styleProps = omitBy(
    {
      flexDirection: direction,
      alignItems: align,
      justifyContent: justify,
      gap,
    },
    (value) => value === undefined,
  );

  return (
    <div
      style={{
        display: 'flex',
        ...styleProps,
      }}
      {...props}
    >
      {children}
    </div>
  );
};
